import axios from 'axios';

const PickupPointsService = {
  async fetch() {
    return axios.get('/order/api/points');
  }
};

export default PickupPointsService;